enum LocationType {
  APP_START = "app-start",
  FIND_ME = "find-me",
  CHECK_IN = "check-in",
  AUTO_VISIT = "auto-visit",
}

export default LocationType;
